import config from '../config';
import ajax from '../services/ajax';
import ScrollMagic from 'scrollmagic';
import postController from '../controllers/post_controller';
import $ from 'jquery';
import _ from 'underscore';
import postShareButtons from './post-share-buttons';
import imageEnlarger from './image-enlarger';
import adManager from '../services/admanager';
import newsletterSignup from './newsletter_signup';
import Router from '../services/router_service';
import OmnitureTracker from '../services/omniture_service';
import AnalyticsService from '../services/analytics_service';
import {extend} from 'underscore';
import cookieUtil from 'js-cookie';
import navbarSearch from '../modules/navbar-search';
import hamburger from '../modules/hamburger';

class PostInfiniteScroll {
    constructor() {
        this.config = config;
        this.enabled = config.get('featureFlags.postInfiniteScroll');
    }

    addScrollEventListeners() {
        const path = window.location.pathname;
        // const mobileBottomSocialBarMarkup = this.$mobileBottomSocialBar.html();
        const navBarMarkup = this.$navBar.html();
        const oldBootstrapConf = extend({}, window.bootstrap_config);
        const oldBootstrapObj = extend({}, window.bootstrap_obj);
        // const $bootstrapDiv = $('.bootstrap-data-infinite-scroll');
        // const oldOmnitureConf = $bootstrapDiv.data('omniture-json');
        const initialScene = new ScrollMagic.Scene({
            triggerElement: '.js-initial-article',
            triggerHook: 'onEnter',
            reverse: true,
            duration: 1,
            offset: 500
        }).addTo(this.controller).on('enter', function onScrollEnter(/* e */) {
            Router.navigate(path);
            navbarSearch.off();
            hamburger.off();
            this.$navBar.html(navBarMarkup);
            hamburger.on();
            navbarSearch.on();
            // this.$mobileBottomSocialBar.html(mobileBottomSocialBarMarkup);
            // OmnitureTracker.trackNewPage(oldOmnitureConf);
            AnalyticsService.trackKrux(oldBootstrapObj, oldBootstrapConf);
            AnalyticsService.trackComscore(oldBootstrapObj);
            AnalyticsService.trackChartbeat(oldBootstrapObj);
            AnalyticsService.trackFacebookAds(oldBootstrapObj);
            AnalyticsService.trackNielsen();
        }.bind(this));
        const scene = new ScrollMagic.Scene({
            triggerElement: this.classname,
            triggerHook: 'onEnter',
            offset: -500,
            reverse: true,
            duration: 1
        }).addTo(this.controller).on('enter', function onScrollEnter(/* e */) {
            this.loadNextPost();
        }.bind(this));
        this.scenesPush(initialScene);
        this.scenesPush(scene);
        this.loadNextPost({first: true});
    }

    loadNextPost(conf) {
        if (this.currentIndex + 1 > this.data.length) {
            $('.infinite-scroll-loading').css({opacity: 0, height: '100px'});
            return false;
        }
        const url = this.data[this.currentIndex].url;
        const title = this.data[this.currentIndex].title;
        ++this.currentIndex;
        this.ajax(url).then(function handleUrlFetched(data) {
            ++this.page;
            const $data = $(data);
            const $header = $data.find('header');
            const $bootstrapDiv = $data.find('.bootstrap-data-infinite-scroll');
            const bootstrapConf = $bootstrapDiv.data('bootstrap-json');
            const bootstrapObj = $bootstrapDiv.data('bootstrap-obj-json');
            const trackingConfig = $bootstrapDiv.data('omniture-json');
            $header.attr('data-url', url);
            $header.addClass('added-infinite-scroll');
            $data.find('.article-wrapper').attr('data-url', url);
            $data.find('header').attr('data-title', title);
            $data.find('.article-wrapper').attr('data-title', title);
            $data.find('.js-post-loadmore').remove();
            const header = $data.find('header')[0].outerHTML;
            const article = $data.find('.article-wrapper')[0].outerHTML;
            const navBarMarkup = $data.find('.nav-bar').html();
            // const mobileBottomSocialBarMarkup = $data.find('.mobile-bottom-social-bar').html();
            const divider = `<div class="no-ad-slug ad-wrapper ad-wrapper-large navbar-ad infinite-scroll-divider-ad"> <div class="ad-unit leaderboard-ad large-ad " data-advertising="flexiblepushdown"> <div class="dart-ad"></div> </div> </div> <div class="no-ad-slug ad-wrapper ad-wrapper-medium navbar-ad"> <div class="ad-unit leaderboard-ad medium-ad " data-advertising="flexibleleaderboard"> <div class="dart-ad"></div> </div> </div>`;
            /* const premarkup = `<div class="infinite-scroll-divider"><span>POPULAR NOW</span></div>`;*/
            let beforeMarkup = `${header} ${article} ${divider}`;
            if (conf && conf.first === true) {
                beforeMarkup = `${divider} ${beforeMarkup}`;
            }
            window.bootstrap_obj = bootstrapObj;
            window.bootstrap_obj.infiniteScrollPageNum = this.page;
            $(beforeMarkup).insertBefore('.infinite-scroll-marker');
            adManager();
            $(window).lazyLoadXT();
            require('../modules/header-slideshow')();
            require('./fc-article-fix')({selector: `[data-url="${url}"]`});
            require('./fc-sharing-popup')();
            /* TODO: fix this*/
            require('./media-scaler')({fitvidsSelector: `[data-url="${url}"]`});
            require('./pym')();
            require('./inline-autoplay-video')();
            require('./custom-content-manager')();
            require('../utils/prose-sanitizer')();
            require('../utils/loaded_promise_util').loadIframes($(`.article-wrapper[data-url="${url}"]`));
            require('../utils/sidebar_positioning_util')($(`.article-wrapper[data-url="${url}"]`));
            imageEnlarger.on();
            postShareButtons.on();
            const localNewsletterSignup = newsletterSignup('.js-newsletter-form');
            localNewsletterSignup.init();
            // postAnalytics();
            this.addUrlUpdateEvent({
                url: encodeURI(url),
                navBarMarkup: navBarMarkup,
                // mobileBottomSocialBarMarkup: mobileBottomSocialBarMarkup,
                trackingConfig,
                bootstrapObj,
                bootstrapConf,
                currentIndex: this.page
            });
        }.bind(this)).catch(function handleUrlFailed(err) {
            if (conf && conf.first) {
                const divider = `<div class="no-ad-slug ad-wrapper ad-wrapper-large navbar-ad infinite-scroll-divider-ad"> <div class="ad-unit leaderboard-ad large-ad " data-advertising="flexiblepushdown"> <div class="dart-ad"></div> </div> </div> <div class="no-ad-slug ad-wrapper ad-wrapper-medium navbar-ad"> <div class="ad-unit leaderboard-ad medium-ad " data-advertising="flexibleleaderboard"> <div class="dart-ad"></div> </div> </div>`;
                $(divider).insertBefore('.infinite-scroll-marker');
                adManager();
            }
            console.error(err);// eslint-disable-line no-console
            this.loadNextPost(); // this happens with fastconews :(
        }.bind(this));
    }

    addUrlUpdateEvent({url, navBarMarkup, /* mobileBottomSocialBarMarkup, */ trackingConfig, bootstrapObj, bootstrapConf, currentIndex}) {
        const scene = new ScrollMagic.Scene({
            triggerElement: `[data-url="${url}"]`,
            triggerHook: 'onEnter',
            reverse: true,
            duration: 1,
            offset: 500
        }).addTo(this.controller)
            .on('enter', function onScrollEnter(/* e */) {
                // this.$mobileBottomSocialBar.html(mobileBottomSocialBarMarkup);
                if (config.get('env') === 'development') {
                    Router.navigate(url.split('8880')[1]);
                } else {
                    Router.navigate(url.split('.com')[1]);
                }
                OmnitureTracker.trackNewPage(trackingConfig);
                AnalyticsService.trackKrux(bootstrapObj, bootstrapConf, trackingConfig);
                AnalyticsService.trackComscore(bootstrapObj);
                AnalyticsService.trackChartbeat(bootstrapObj);
                AnalyticsService.trackFacebookAds(bootstrapObj);
                AnalyticsService.trackOmnitureEvent('event31', currentIndex);
                AnalyticsService.trackInfiniteScrollPage(currentIndex);
                AnalyticsService.trackNielsen();
                AnalyticsService.gaTrackPageView();
                navbarSearch.off();
                hamburger.off();
                this.$navBar.html(navBarMarkup);
                hamburger.on();
                navbarSearch.on();
            }.bind(this));
        this.scenesPush(scene);
    }

    transformData() {
        const site = this.config.get('bootstrap_obj.site.slug');
        const regEx = new RegExp(site);
        this.data = this.data.map(function (obj) {
            if (regEx.test(obj.url) === false) {

                return false;
            }
            if (obj.id === this.id) {
                return false;
            }
            let url = obj.url;

            if (/beta/.test(window.location.host.split('.')[0])) {
                const stagingHost = window.location.host.split('.')[0];
                url = obj.url.replace('//www', `http://${stagingHost}`);
                url = url;
            }

            return {
                id: obj.id,
                url,
                title: obj.title
            };
        }.bind(this));
        this.data = _.compact(this.data);
        return this;
    }

    on() {
        const $marker = $('.infinite-scroll-marker');
        if (this.enabled && $marker.length) {
            // this.$mobileBottomSocialBar = $('.mobile-bottom-social-bar');
            this.$navBar = $('.nav-bar');
            this.scenes = [];
            this.id = this.config.get('bootstrap_obj.id');
            this.classname = '.js-post-loadmore';
            this.$el = $(this.classname);
            this.controller = new ScrollMagic.Controller();
            this.postController = postController;
            this.ajax = ajax;
            try {
                this.data = JSON.parse($('[data-infinite-scroll]').attr('data-infinite-scroll'));
            } catch (err) {
                this.data = [{}];
            }
            this.transformData();
            this.currentIndex = 0;
            this.page = 0;
            this.addScrollEventListeners();
        }
    }

    scenesPush(scene) {
        this.scenes.push(scene);
        this.scenes.forEach(function (sc) {
            sc.refresh();
        });
    }

    getNextPost() {
        const nextStory = cookieUtil.get('fc_next_story');
        if (nextStory && this.data[Number(nextStory) + 1]) {
            cookieUtil.set('fc_next_story', Number(nextStory) + 1);
            return this.data[Number(nextStory)].url;
        }
        if (this.data[this.currentIndex + 1]) {
            cookieUtil.set('fc_next_story', this.currentIndex + 1);
            return this.data[this.currentIndex + 1].url;
        }
        cookieUtil.set('fc_next_story', 0);
        return this.data[this.data.length - 1].url;
    }
}

export default new PostInfiniteScroll();
